<template>
  <!--<div v-show="(auth.user.role == 'ADMIN' || auth.user.role == 'VENDOR')">-->
  <div>
    <Head :title="`${form.fullname} ${form.last_name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/users">Users</Link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password" />
          <select-input v-model="form.role" :error="form.errors.role" class="pb-8 pr-6 w-full lg:w-1/2" label="Role"  v-bind:value="form.role">
            <option v-for="UserRole in UserRoles" v-bind:value="UserRole.toUpperCase()">
              {{UserRole.toUpperCase()}}
            </option>
          </select-input>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
          <div class="w-full">Vendor:<br/><br/>
            <SelectInput  id="vendor" class="mb-4 w-full" v-model="form.vendor" :error="form.errors.vendor" >
              <option value="0">None (CarbonMark)</option>
              <option v-for="vendor in this.vendors.data" :value="vendor.id"> {{ vendor.vendorname }}</option>
            </SelectInput>
          </div>
        </div>
        <div class="p-8" v-show="auth.user.role == 'ADMIN'">
          <h2 class="lg">Jobsite Access:</h2><br/><br/>
          <div v-for="jobsite in jobsites.data" class="p-2 jobsite-access-row"><label><input class="jobsite-checkbox" type="checkbox" @change="jobsitecalc" :id="'jobsite-' + jobsite.id" :name="'jobsite-' + jobsite.id" /> &nbsp; &nbsp; &nbsp; &nbsp; {{jobsite.sitename}}</label></div>
          <text-input id="jobsiteaccess" v-model="form.jobsiteaccess" :error="form.errors.jobsiteaccess" type="hidden" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!user.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy"  v-show="auth.user.role == 'ADMIN'">Delete User</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit"  v-show="auth.user.role == 'ADMIN'">Update User</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
  .jobsite-access-row:nth-child(odd) {
    background:#FAFAFA;
  }
</style>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import {
  UserRoles,
} from "./../../../enums";

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    auth: Object,
    user: Object,
    jobsites: Object,
    vendors: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: this.user.password,
        role: this.user.role,
        photo: null,
        vendor: this.user.vendor,
        jobsiteaccess: this.user.jobsiteaccess,
      }),
      UserRoles,
    }
  },
  mounted() {
    this.jobsiteload();
    this.checkForFirstCookie();
  },
  methods: {
    checkForFirstCookie() {
      window.setTimeout(function() {
        if (document.querySelector('#jobsiteselector').value == '' && document.querySelectorAll('#jobsiteselector option').length == 2) {
          document.querySelector('#jobsiteselector').selectedIndex = 1;
          var eventchange = new Event('eventchange');
          document.querySelector('#jobsiteselector').dispatchEvent(eventchange);

          document.cookie = 'jobsite=' + document.querySelectorAll('#jobsiteselector option')[1].value +';path=/;';
          try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
          } catch(e) { console.error(e); }
         }
      },250);
    },
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    update() {
      this.form.jobsiteaccess = document.getElementById('jobsiteaccess').value;
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
    jobsitecalc() {
      var jsaccess = [];
      var jsa = Array.from(document.getElementsByClassName('jobsite-checkbox'));
      jsa.forEach((v) => {
        //jsaccess[parseInt(v.id.split('-')[1])] = jsa.value;
        if (v.checked) {
          jsaccess[parseInt(v.id.split('-')[1])] = 1;
        }
      });
      document.getElementById('jobsiteaccess').value = JSON.stringify(jsaccess);
    },
    jobsiteload() {
      window.setTimeout(function(){
        var jsli = document.getElementById('jobsiteaccess').value;
        if (jsli) { var jsl = JSON.parse(jsli); } else { var jsl = []; }
        
        jsl.forEach((jsa, jsk) => {
          if (jsa) { document.getElementById('jobsite-' + jsk).checked = true; }
        });
      },500);
    },
  },
}
</script>